import { Injectable } from '@angular/core';
import { SnackBarService } from '../components/snack-bar/snack-bar.service';


@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  constructor(public snackBarService: SnackBarService) { }

  public warning(msg: any) {
    this.snackBarService.warn(msg);
  }

  public information(msg: any) {
    this.snackBarService.info(msg);
  }

  public successful(msg: any) {
    this.snackBarService.success(msg);
  }

  public error(msg: any) {
    this.snackBarService.error(msg);
  }

  public confirmation(msg: any, event: Function = null, msgSi: string = 'Si', msgNo: string = 'No') {
    this.snackBarService.confirm(msg, event, msgSi, msgNo);
  }

}
